module.exports = __webpack_public_path__ + "static/img/TN@3x.55aef160.jpg";